import React from 'react';

import { injectIntl } from 'react-intl';

import './try-again.component.scss';

const ErrorLabel = ({ label }) => (
	<div className="checkout-error-form">
		{label}
	</div>
);


const TryAgain = ({ handleFunction, intl }) => (
	<div className="row try-again">

		<ErrorLabel
			label={intl.formatMessage({ id: 'try-again.label' })}
		/>

		{handleFunction
		&& (
			<button className="btn blue" onClick={handleFunction}>
				{intl.formatMessage({ id: 'try-again.button' })}
			</button>
		)
		}
	</div>
);

export default injectIntl(TryAgain);
